import {Component, Inject, OnInit} from '@angular/core';
import {MatDialog, MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { AppService } from 'src/app/services/app.service';

@Component({
    selector: 'show-rapports-archiv-dialog',
    templateUrl: 'show-rapports-archiv-dialog.component.html',
    styleUrls: ['show-rapports-archiv-dialog.component.scss']
})
export class ShowRapportsArchivDialog implements OnInit {
    rapports: any;
    messageError: string;
    rapportStep: number;
    subscribe: any = [];
    dossier: any;
    name: string;

    constructor(
        public dialogRef: MatDialogRef<ShowRapportsArchivDialog>,
        private appService: AppService,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {}

    ngOnInit() {
        this.rapports = this.data.rapports
        let iddossier = this.data.iddossier
        this.appService.getDossierById(iddossier).subscribe((res)=>{
            if(res.result.error){
                this.dismissDialog()
            }else if(res.result && res.result.datas && res.result.datas[0])
            this.dossier = res.result.datas[0];
        })
    }

    folding(e){
        let balise = e.target.tagName
        if(balise == "H1"){
            let ok = true
            let ok2 = true
            let ok3 = true
            if((<HTMLElement>e.target.parentElement).classList.contains("plie")){
                (<HTMLElement>e.target.parentElement).classList.remove("plie")
                let target = e.target.parentElement
                while(ok){
                    if((<HTMLElement>target.nextElementSibling) && target.nextElementSibling.tagName == "DIV" && (<HTMLElement>target.nextElementSibling).classList.contains("rapport-display") ){
                        (<HTMLElement>target.nextElementSibling).classList.add("plie")
                        target = target.nextElementSibling
                    }else{
                        ok = false
                    }
                }
                let target3 = e.target.parentElement
                while(ok3){
                    if((<HTMLElement>target3.previousElementSibling) && target3.previousElementSibling.tagName == "DIV" && (<HTMLElement>target.previousElementSibling).classList.contains("rapport-display") ){
                        (<HTMLElement>target3.previousElementSibling).classList.add("plie")
                        target3 = target3.previousElementSibling
                    }else{
                        ok3 = false
                    }
                }
                let target2 = e.target
                while(ok2){
                    if((<HTMLElement>target2.nextElementSibling) && target2.nextElementSibling.tagName !== balise && target2.nextElementSibling.tagName !== "DIV" && target2.nextElementSibling.tagName !== "APP-FOOTER" ){
                        (<HTMLElement>target2.nextElementSibling).classList.remove("plie")
                        if ((<HTMLElement>target2).hasChildNodes()) {
                            let children = (<HTMLElement>target2).childNodes;
                            for (var i = 0; i < children.length; i++) {
                                if((<HTMLElement>target2.nextElementSibling).classList.contains("plie")){
                                    (<HTMLElement>target2.nextElementSibling).classList.remove("plie")
                                }
                            }
                        }
                        target2 = target2.nextElementSibling
                    }else{
                        ok2 = false
                    }
                }
                let offset = e.target.parentElement.offsetTop;
                window.scrollTo({
                    top: offset,
                    behavior: 'smooth'
                })
            }else{
                (<HTMLElement>e.target.parentElement).classList.add("plie")
                let oktarget = true
                let target = e.target
                while(oktarget){
                    if((<HTMLElement>target.nextElementSibling) && target.nextElementSibling.tagName == "DIV" && (<HTMLElement>target.nextElementSibling).classList.contains("rapport-display") ){
                        (<HTMLElement>target.nextElementSibling).classList.add("plie")
                        target = target.nextElementSibling
                    }else{
                        oktarget = false
                    }
                }
            }
        }else if(balise == "H2" || balise == "H3"){
            let ok = true
            if((<HTMLElement>e.target).classList.contains("plie")){
                (<HTMLElement>e.target).classList.remove("plie")
                let target = e.target
                while(ok){
                    if((<HTMLElement>target.nextElementSibling) && target.nextElementSibling.tagName !== balise && target.nextElementSibling.tagName !== "DIV" && target.nextElementSibling.tagName !== "APP-FOOTER" ){
                        (<HTMLElement>target.nextElementSibling).classList.remove("plie")
                        target = target.nextElementSibling
                    }else{
                        ok = false
                    }
                }
            }else{
                (<HTMLElement>e.target).classList.add("plie")
                let target = e.target
                while(ok){
                    if((<HTMLElement>target.nextElementSibling) && target.nextElementSibling.tagName !== balise && target.nextElementSibling.tagName !== "DIV" && target.nextElementSibling.tagName !== "APP-FOOTER" ){
                        if(balise == "H3" && target.nextElementSibling.tagName == "H2" ){
                            ok = false
                        }else{
                            (<HTMLElement>target.nextElementSibling).classList.add("plie")
                            target = target.nextElementSibling
                        }
                    }else{
                        ok = false
                    }
                }
            }
        }
    }
        
    printRap(){
        this.messageError = ""
        let nbRapportTotal = document.querySelectorAll('#section-to-print .rapport-display').length
        let nbRapportPlie = document.querySelectorAll('#section-to-print .rapport-display.plie').length;
        if(nbRapportPlie == nbRapportTotal){
            this.messageError = "Veuillez déplier le rapport que vous souhaiter exporter."
        }
        if(!this.messageError)
            window.print()
    }
    downloadRapport(type){
        this.messageError = ""
        let targets = document.querySelectorAll('.container-rapport .rapport-integrated');
        let targetsNotPlie = document.querySelectorAll('.container-rapport .rapport-integrated:not(.plie)').length;
        if(targetsNotPlie == 1){
            let i=0;
            targets.forEach(target=>{
                if(!(<HTMLElement>target).classList.contains("plie")){
                    this.rapportStep = i;
                }
                i++;
            })
            let calc = this.rapports[this.rapportStep].calcul;
            if(this.subscribe['downloadrapport']){
                this.subscribe['downloadrapport'].unsubscribe();
            }
            let dategeneration = new Date().toLocaleDateString("fr-FR", {hour:"2-digit", minute:"2-digit", second:"2-digit"})
            this.name = this.dossier.nom+"_"+this.dossier.prenom+"_"+calc+"_"+dategeneration+'.'+type.toLowerCase()
            this.name = this.name.replace(' ', '_')
            this.subscribe['downloadrapport'] = this.appService.downloadrapport(this.dossier.id,calc, type).subscribe((res)=>{
                if(res){
/* #1551 problème avec SAFARI
                    let blob;
                    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                        if(type == "PDF"){
                            blob = new Blob([res], { type: 'application/pdf' })
                        }else{
                            blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' })
                        }
                        window.navigator.msSaveOrOpenBlob(blob, this.name);
                    } else {// other browsers
                        if(type == "PDF"){
                            blob = new File([res], this.name, {type: "application/pdf"});
                        }else{ 
                            blob = new File([res], this.name, {type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document"});
                        }
                        let exportUrl = window.URL.createObjectURL(blob);
                        window.open(exportUrl);
                        URL.revokeObjectURL(exportUrl);
                    }
*/
                    let aDownload = document.createElement('a')
                    aDownload.download = this.name
                    aDownload.href = URL.createObjectURL(res)
                    document.body.appendChild(aDownload)
                    aDownload.click()
                    document.body.removeChild(aDownload)
                }else{
                    this.messageError = "Une erreur est survenue lors de l'export du rapport.";
                    setTimeout(()=>{this.messageError = ""}, 5000);
                }
                
            })
        }else{
            this.messageError = "Veuillez déplier seulement le rapport que vous souhaiter télécharger."
        }
    }

    unfoldAll(){
        let elements = document.querySelectorAll('.plie')
        elements.forEach(element => {
            (<HTMLElement>element).classList.remove("plie")
                
        });
    }
    foldAll(){
        let targets = document.querySelectorAll('.container-rapport .rapport-integrated > *');
        let targetsParents = document.querySelectorAll('.container-rapport .rapport-integrated');
        targets.forEach(target=>{
            (<HTMLElement>target).classList.add("plie");
        }) 
        targetsParents.forEach(target=>{
            (<HTMLElement>target).classList.add("plie");
        })
    }
    dismissDialog(){
        this.dialogRef.close();
    }
}